import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from 'src/hooks';

import { getCountry } from 'src/utils/urls';

import { CountryObj } from 'src/types/countryType';

async function fetchCountry({ token, tokenType }: TVaribles): Promise<Array<APIResult>> {
  const response = await fetch(getCountry, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

type APIResult = {
  Data : Array<CountryObj>;
  isSuccess: boolean;
  statusCode: number;
}

type TVaribles = {
  token: string;
  tokenType: string;
};

// type TResult = Array<CountryType>;

type TResult = any;
type TError = { message: string };

function useGetCountry(): UseQueryResult<APIResult , TError> {
  const { token, tokenType } = useAuth();

  return useQuery(
    ['get_country'],
    async () => {
      const result = fetchCountry({ token, tokenType });
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetCountry };
